import React from 'react'
import Tabs, { Item } from '../../../components/Tabs'
// import FilterButton from '../FiltersButton/FilterButton'
import './MenuCategories.css'

const MenuCategories = ({
  // onFilter,
  categories,
  selectedCategoryId,
  changeSelectedCategory
  // filtersData,
  // filters
}) => {
  return (
    <div className="menu-categories-navigation">
      <div className="menu-categories-content">
        <div className="menu-categories">
          <Tabs>
            {categories.map(category => (
              <Item
                key={category.id}
                label={`${category.title}`}
                selected={selectedCategoryId === category.id}
                onClick={() => {
                  changeSelectedCategory(category.id)
                }}
              />
            ))}
          </Tabs>
        </div>
        <div className="filters-container">
          {/* <FilterButton
            onFilter={onFilter}
            filtersData={filtersData}
            filters={filters}
          /> */}
        </div>
      </div>
    </div>
  )
}

export default MenuCategories



// WEBPACK FOOTER //
// ./src/modules/Menu/MenuCategories/MenuCategories.jsx